import { useEffect } from 'react';
import { QUERY_KEYS } from '../constants';
import { KYC_RETURN_PENDING_STORAGE_KEY } from '../utils/kyc';
import { useInvalidateQuery } from './useInvalidateQuery';

const useHandleComplyCubeReturn = () => {
  const invalidateQuery = useInvalidateQuery();

  useEffect(() => {
    const url = new URL(window.location.href);
    const complyCubeStatus = url.searchParams.get('complycube');

    if (!complyCubeStatus) {
      return;
    }

    sessionStorage.setItem(KYC_RETURN_PENDING_STORAGE_KEY, 'true');
    invalidateQuery([QUERY_KEYS.customerData]);
    url.searchParams.delete('complycube');
    window.history.replaceState(null, '', url.toString());
  }, [invalidateQuery]);
};

export default useHandleComplyCubeReturn;
